var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"touch",rawName:"v-touch:touchhold",value:(_vm.touchHoldHandler),expression:"touchHoldHandler",arg:"touchhold"}],on:{"contextmenu":function($event){$event.preventDefault();_vm.vehicle.vehicleFlags?.transfer == 1 ||
    _vm.vehicle.vehicleFlags?.transfer == 4
      ? _vm.$refs.menuTransfer.open($event, 'Payload')
      : ''}}},[_vm._t("default"),(
      _vm.vehicle.vehicleFlags?.transfer == 1 ||
      _vm.vehicle.vehicleFlags?.transfer == 4
    )?_c('ContextMenu',{ref:"menuTransfer"},[[_c('ContextMenuItem',{nativeOn:{"click":function($event){return _vm.markTransferAsComplete()}}},[_vm._v(" Mark as complete ")])]],2):_vm._e(),_c('TaskUpdateStatusModalVue',{attrs:{"tasks":_vm.tasks,"id":_vm.vehicle.id}})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }